import React from 'react';
import Box from '../Box/Box';
import PrismicLink from '../PrismicLink/PrismicLink';
import Image from '../Image/Image';
import { css } from 'styled-components';
import Inline from '../Inline/Inline';
import { rem } from 'polished';

export const MobileStoreButtons = ({ data }) => {
    const {
        app_store_icon,
        app_store_link,
        google_store_icon,
        google_store_link,
    } = data;

    return (
        <Inline gap={rem(8)}>
            <PrismicLink link={app_store_link}>
                <Image img={app_store_icon} />
            </PrismicLink>
            <PrismicLink link={google_store_link}>
                <Image img={google_store_icon} />
            </PrismicLink>
        </Inline>
    );
};
